// Loading screen switch.
//   true  = animated splash (AppSplash.vue)
//   false = the previous overlay (logo + v-progress-linear)
// The pre-Vue screen in public/index.html has its own `useNewSplash` flag;
// keep both the same.
export const useNewSplash = true
